module.exports = __webpack_public_path__ + "resources/img/equipment_tab4_img4_m.782d148bc1a74b6825eae5db7d261759.jpg";